export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'match',
        range: 'within'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance'],
        range: ['exact', 'within', 'low', 'high']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Duration',
        category: 'Game',
        description: 'Publisher set duration range for the game.',
        summarise: {
            prefix: 'Duration'
        },
        unit: 'minute'
    }
}